module.exports = __webpack_public_path__ + "static/people_pop16-d684a3a87771254c4a21a50ef99ab90b.png";